<template>
    <div>

        <div class="container-fluid dop-pack-header-wrapper">
            <div class="row no-gutters">
                <div class="col text-center dop-pack-header my-2">
                    {{ $t('dop_pack_title') }}
                </div>
            </div>
        </div>

        <div class="container-fluid lessons-tabs">
            <div class="container">
                <div class="row justify-content-center lessons-tabs-row">
                    <div class="col-auto" v-for="(video, index) in videos"
                         :key="video.idelement">
                        <base-button
                                @click="currentTabIndex = video.idelement"
                                :class="[{'active': currentTabIndex === video.idelement}]">
                            <span class="dashed-text" v-if="videos.length === 1">{{ $t('lesson') }}</span>
                            <span class="dashed-text" v-else>{{ $t('lesson') }} {{ index + 1}}</span>
                        </base-button>
                    </div>
                    <div class="col-auto" v-if="materials.length > 0">
                        <base-button
                                @click="currentTabIndex = materials[0].idelement"
                                :class="[{'active': currentTabIndex === materials[0].idelement}]">
                            <span class="dashed-text">{{ $t('materials') }}</span>
                        </base-button>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="video in videos" :key="video.idelement">
            <div class="container-fluid tab-video" v-if="currentTabIndex === video.idelement">
                <lesson-video :element="video" :lesson="lesson" :hideToTest="true" :hidePoints="true"
                              @totests="toMaterials"
                              @tolessons="toLessons"/>
            </div>
        </div>


        <div class="container-fluid tab-materials"
             v-if="materials.length > 0 && currentTabIndex === materials[0].idelement">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <lesson-material v-if="materials" :materials="materials" :lesson="lesson" :hidePoints="true"/>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<style src="@/assets/poliglotiki/main.css">


</style>
<style scoped>


</style>
<style scoped>
    .dop-pack-header {
        font-family: "Intro Bold";
        font-size: 24px;
        color: rgb(35, 28, 55);
    }

    .dop-pack-header-wrapper {
        border-top: 1px solid rgb(215, 225, 229);
        background-color: rgb(255, 219, 0);
        box-shadow: 2px 2px 6px 1px #0003;
    }

</style>

<script>
    import LessonsApi from "../data/LessonsApi";
    import {eventBus} from "../main";
    import LessonVideo from "./LessonVideo";
    import LessonMaterial from "./LessonMaterial";
    import courseApi from "../data/CourseApi";
    import userApi from "../data/UserApi";

    export default {
        props: ['id'],
        components: {
            LessonMaterial,
            LessonVideo,
        },
        data() {
            return {
                currentTabIndex: 0,
                testTabIndex: -1,
                lesson: null,
                videos: [],
                materials: [],
                course: null,
                lessonsIds: [],
                lessonsId: null,
            };
        },
        methods: {
            toLessons() {
                this.$router.push('/course/' + this.course.slug)
            },

            toMaterials() {
                this.currentTabIndex = this.materials[0].idelement
            },

            getColor(lesson) {
                if (this.lessonsId == lesson.idlesson) return 'orange'
                return 'gray'
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        },

        mounted() {
            userApi.check()
                .then(() => {
                    LessonsApi.fetchLessonsIds(this.id)
                        .then(response => {
                            this.lessonsIds = response
                            this.lessonsId = this.lessonsIds[0].idlesson
                            //Привязка "общего" для курса доппакета идет к уроку с номером 1 (первый в выборке fetchLessonsIds)
                            LessonsApi.fetchLesson(this.lessonsId)
                                .then(response => {
                                    this.lesson = response
                                    courseApi.fetchCourse(this.lesson.idcourse)
                                        .then(response => {
                                            this.course = response

                                            LessonsApi.fetchElements(this.lessonsId)
                                                .then(response => {
                                                    let data = response
                                                    data.forEach(element => {
                                                        if (element.idelementtype === 'addpack-video') {
                                                            this.videos.push(element)
                                                        }
                                                        if (element.idelementtype === 'addpack') {
                                                            this.materials.push(element)
                                                        }
                                                        if (this.videos.length > 0) {
                                                            this.currentTabIndex = this.videos[0].idelement
                                                        } else if (this.materials.length > 0) {
                                                            this.currentTabIndex = this.materials[0].idelement
                                                        }
                                                    })
                                                })
                                                .catch(error => {
                                                    if (error.response.status === 403) {
                                                        this.$router.push('/order/' + this.lesson.idcourse)
                                                    }
                                                    let data = error.response.data
                                                    this.error = this.pretty(data)
                                                    this.loading = false
                                                })

                                            eventBus.$emit('setNavBarTitle', this.lesson.lesson);
                                            document.title = this.lesson.lesson

                                        })
                                        .catch(error => {
                                            let data = error.response.data
                                            this.error = this.pretty(data)
                                            this.loading = false
                                        })

                                })
                                .catch(error => {
                                    let data = error.response.data
                                    this.error = this.pretty(data)
                                    this.loading = false
                                })


                        })
                        .catch(error => {
                            let data = error.response.data
                            this.error = this.pretty(data)
                            this.loading = false
                        })


                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

        },

    };
</script>
<style></style>
